'use strict';

class Breakpoint {

    /**
     * Get the value in pixels of a breakpoint
     * @param breakpoint
     * @return {*}
     */
    static get(breakpoint) {

        return breakpoint ? App.Settings.breakpoints[breakpoint] : false;
    }

    /**
     * Get the Window width
     * @return {*}
     */
    static getCurrentWindowWidth() {

        let currentWidth = App.Globals.window.innerWidth;

        App.Globals.window.addEventListener('resize', () => {
            currentWidth = App.Globals.window.innerWidth;
        }, false);

        return currentWidth;
    }

    /**
     * Get the value in pixels of one larger breakpoint,
     * false in case there's no larger breakpoint
     * @param breakpoint
     * @return {*}
     */
    static getNextBreakpoint(breakpoint) {

        let allBreakpoints = App.Settings.breakpoints;

        let i = 0;
        let next = false;

        for (let key in allBreakpoints) {
            if (allBreakpoints.hasOwnProperty(key)) {
                if (next) {
                    next = false;

                    return key;
                }

                if (key === breakpoint) {
                    next = true;
                }

                i++;
            }
        }

        return false;
    }

    /**
     * Checks if the exact breakpoint is matched
     * @param breakpoint
     * @return {*}
     */
    static is(breakpoint) {

        breakpoint = breakpoint.trim().split(' ');

        if (breakpoint.length > 1 && breakpoint[1] === 'only') {

            let nextBreakpoint = this.getNextBreakpoint(breakpoint[0]);
            let endWidth = (nextBreakpoint ? (this.get(nextBreakpoint) - 1) : this.getCurrentWindowWidth());

            return this.atLeast(breakpoint[0]) && this.getCurrentWindowWidth() <= endWidth;
        } else {

            return this.atLeast(breakpoint[0]);
        }
    }

    /**
     * Checks if the minimum breakpoint is matched
     * @param breakpoint
     * @return {boolean}
     */
    static atLeast(breakpoint) {

        return this.getCurrentWindowWidth() >= this.get(breakpoint);
    }

}

module.exports = Breakpoint;
